import React from 'react';
import './TileTags.css';

interface TileTagsProps {
  tags: string[];
}

const TileTags: React.FC<TileTagsProps> = ({ tags }) => {
  return (
    <div className="tile-tags-container">
      {tags.map((tag, index) => (
        <span key={index} className="tile-tag-item">
          {tag}
        </span>
      ))}
    </div>
  );
};

export default TileTags;